import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-dimension-responsible-selection',
    templateUrl: './dimension-responsible-selection.component.html',
    styleUrls: ['./dimension-responsible-selection.component.scss'],
    standalone: false,
})
export class DimensionResponsibleSelectionComponent {
    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
    ) {}

    onSubmit() {
        this.ref.close({
            selectedResponsable: (this.config.data as { selectedResponsable: string }).selectedResponsable,
        });
    }

    onCancel() {
        this.ref.close({ cancelled: true });
    }
}
